import React from "react";
import { Link } from "react-router-dom";
import "./balloon.css";

function BalloonRides() {
  const balloonSpots = [
    {
      name: "Dambulla",
      highlight: "Spectacular sunrise flights over ancient caves",
      image: "/balloon2.jpg",
    },
    {
      name: "Sigiriya",
      highlight: "Fly above the iconic Lion Rock fortress",
      image: "/balloon1.jpg",
    },
    {
      name: "Kandalama",
      highlight: "Views of serene lakes and wildlife reserves",
      image: "/balloon3.jpg",
    },
        {
      name: "Habarana",
      highlight: "Sail in the tranquil skies and enjoy the beautiful views",
      image: "/balloon4.jpg",
    },
  ];

  return (
    <div className="balloon-page">
      {/* Banner Section */}
      <div className="banner-section">
        <div className="banner-overlay"></div>
        <img
          src="/ballon-banner.jpg"
          alt="Hot Air Balloon Rides"
          className="banner-image"
        />
        <div className="banner-content">
          <h1 className="banner-title animate-fade-in">
            <span>
              <b>Balloon</b> Rides
            </span>
          </h1>
          <div className="banner-description animate-slide-up">
            <p className="para-balloon">
              Experience the magic of hot air balloon rides over Sri Lanka’s
              stunning landscapes. Drift peacefully and take in breathtaking
              panoramic views.
            </p>
            <Link to="/booking">
              <button className="book-now-btn animate-pulse">
                Book Your Balloon Ride
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Balloon Ride Spots Section */}
      <div className="wildlife-areas-section">
        <h2 className="section-title">Popular Balloon Ride Locations</h2>
        <p className="section-subtitle">See Sri Lanka from a breathtaking new angle</p>

        <div className="wildlife-areas-grid">
          {balloonSpots.map((spot, index) => (
            <div className="wildlife-area-card" key={index}>
              <div className="area-image-container">
                <img
                  src={spot.image}
                  alt={spot.name}
                  className="area-image"
                  loading="lazy"
                />
                <div className="area-overlay"></div>
              </div>
              <div className="area-info">
                <h3>{spot.name}</h3>
                <p>{spot.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Cards */}
      <section className="info-section">
        <div className="info-card">
          <i className="fas fa-hot-air-balloon icon"></i>
          <h3 className="desc-heading">Safety First</h3>
          <p className="desc-para">
            Expert pilots and rigorous safety protocols ensure a smooth ride.
          </p>
        </div>
        <div className="info-card">
          <i className="fas fa-camera icon"></i>
          <h3 className="desc-heading">Stunning Views</h3>
          <p className="desc-para">Capture breathtaking aerial photography.</p>
        </div>
        <div className="info-card">
          <i className="fas fa-globe icon"></i>
          <h3 className="desc-heading">Memorable Experience</h3>
          <p className="desc-para">
            A once-in-a-lifetime adventure you'll never forget.
          </p>
        </div>
      </section>

      {/* Quote Section */}
      <section className="quote-section">
        <blockquote>
          “The sky is not the limit, it’s only the beginning.” 
        </blockquote>
        {/* <cite>— Unknown</cite> */}
      </section>
    </div>
  );
}

export default BalloonRides;
